(function () {
  'use strict';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.getAttribute('data-initialized') === 'true') return;
    sectionEl.setAttribute('data-initialized', 'true');

    var track = sectionEl.querySelector('.agency-testimonials__track');
    if (!track) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.animationPlayState = 'paused';
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-agency-testimonials]');
    sections.forEach(function (el) {
      el.removeAttribute('data-initialized');
      initSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sectionId = e.detail && e.detail.sectionId;
      var sectionEl = sectionId ? document.getElementById('agency-testimonials-' + sectionId) : null;
      if (sectionEl) {
        sectionEl.removeAttribute('data-initialized');
        initSection(sectionEl);
      } else {
        initAll();
      }
    });
  }
})();
